import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useResultsChallenges = (name, options = {}) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['resultsChallenges', name],
    queryFn: async () => {
      const params = name ? { name: name } : {};
      const response = await restClient({
        url: `${prefix}/results/challenge-names`,
        method: 'GET',
        params
      });
      return response;
    },
    staleTime: 0, 
    cacheTime: 0, 
    refetchOnWindowFocus: false,
    ...options
  });
};
